import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';


import { MatFormFieldModule } from '@angular/material/form-field';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatSelectModule } from '@angular/material/select';
import { MatOptionModule } from '@angular/material/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatInputModule } from '@angular/material/input';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material/core';
import { MatDialogModule } from '@angular/material/dialog';
import { MatMenuModule } from '@angular/material/menu';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatTooltipModule } from '@angular/material/tooltip';

import { ButtonModule } from 'primeng/button';
import { TreeModule  } from 'primeng/tree';
import { ListboxModule } from 'primeng/listbox';

import { BhubTreeComponent } from './components/bhub-tree/bhub-tree.component';
import { FilterBarComponent } from './components/filter-bar/filter-bar.component';
import { DatePickerComponent } from './components/date-picker/date-picker.component';
import { DatePickerModalComponent } from './components/date-picker-modal/date-picker-modal.component';
import { FileBrowserModalComponent } from './file-browser-modal/file-browser-modal.component';

// View Cell Components
import { TextCellComponent } from './components/view-cells/text-cell/text-cell.component';
import { FilterListCellComponent } from './components/view-cells/filter-list-cell/filter-list-cell.component';
import { InputFieldCellComponent } from './components/view-cells/input-field-cell/input-field-cell.component';
import { LookupDialogComponent } from './components/view-cells/input-field-cell/lookup-dialog/lookup-dialog.component';
import { MultiSelectCellComponent } from './components/view-cells/multi-select-cell/multi-select-cell.component';
import { ListDisplayCellComponent } from './components/view-cells/list-display-cell/list-display-cell.component';
import { CheckboxCellComponent } from './components/view-cells/checkbox-cell/checkbox-cell.component';
import { ActionCellComponent } from './components/view-cells/action-cell/action-cell.component';
import { DataDisplayCellComponent } from './components/view-cells/data-display-cell/data-display-cell.component';
import { NoteBlockCellComponent } from './components/view-cells/note-block-cell/note-block-cell.component';
import { RadialButtonCellComponent } from './components/view-cells/radial-button-cell/radial-button-cell.component';
import { DatetimePickerCellComponent } from './components/view-cells/datetime-picker-cell/datetime-picker-cell.component';
import { ImageCellComponent } from './components/view-cells/image-cell/image-cell.component';
import { DataEntryCellComponent } from './components/view-cells/data-entry-cell/data-entry-cell.component';
import { LookupCellComponent } from './components/view-cells/lookup-cell/lookup-cell.component';
// PDF Cell Components
import { PdfTextCellComponent } from './components/view-cells/pdf-text-cell/pdf-text-cell.component';
import { PdfImageCellComponent } from './components/view-cells/pdf-image-cell/pdf-image-cell.component';
import { PdfFieldCellComponent } from './components/view-cells/pdf-field-cell/pdf-field-cell.component';
import { PdfTableCellComponent } from './components/view-cells/pdf-table-cell/pdf-table-cell.component';
import { PdfPageBreakCellComponent } from './components/view-cells/pdf-page-break-cell/pdf-page-break-cell.component';
import { PdfDatetimeCellComponent } from './components/view-cells/pdf-datetime-cell/pdf-datetime-cell.component';
import { PdfRowCellComponent } from './components/view-cells/pdf-row-cell/pdf-row-cell.component';
import { CalculationCellComponent } from './components/view-cells/calculation-cell/calculation-cell.component';
import { PdfListCalcCellComponent } from './components/view-cells/pdf-list-calc-cell/pdf-list-calc-cell.component';
import { ListCalcCellComponent } from './components/view-cells/list-calc-cell/list-calc-cell.component';
import { DataEntryTableCellComponent } from './components/view-cells/data-entry-table-cell/data-entry-table-cell.component';
import { FileReferenceCellComponent } from './components/view-cells/file-reference-cell/file-reference-cell.component';
import { PdfGridCellComponent } from './components/view-cells/pdf-grid-cell/pdf-grid-cell.component';
import { PdfCheckboxCellComponent } from './components/view-cells/pdf-checkbox-cell/pdf-checkbox-cell.component';
import { PdfLineCellComponent } from './components/view-cells/pdf-line-cell/pdf-line-cell.component';
import { EmailComposeCellComponent } from './components/view-cells/email-compose-cell/email-compose-cell.component';

// Re-export interfaces for external use
export { DatePickerValue, RelativeDateOption } from './components/date-picker/date-picker.component';
export { DatePickerModalData } from './components/date-picker-modal/date-picker-modal.component';




@NgModule({
  declarations: [
    FilterBarComponent,
    BhubTreeComponent,
    DatePickerComponent,
    DatePickerModalComponent,
    FileBrowserModalComponent,
    // View Cell Components
    TextCellComponent,
    FilterListCellComponent,
    MultiSelectCellComponent,
    ListDisplayCellComponent,
    InputFieldCellComponent,
    LookupDialogComponent,
    CheckboxCellComponent,
    ActionCellComponent,
    DataDisplayCellComponent,
    NoteBlockCellComponent,
    RadialButtonCellComponent,
    DatetimePickerCellComponent,
    ImageCellComponent,
    DataEntryCellComponent,
    LookupCellComponent,
    // PDF Cell Components
    PdfTextCellComponent,
    PdfImageCellComponent,
    PdfFieldCellComponent,
    PdfTableCellComponent,
    PdfPageBreakCellComponent,
    PdfDatetimeCellComponent,
    PdfRowCellComponent,
    CalculationCellComponent,
    ListCalcCellComponent,
    PdfListCalcCellComponent,
    DataEntryTableCellComponent,
    FileReferenceCellComponent,
    PdfGridCellComponent,
    PdfCheckboxCellComponent,
    PdfLineCellComponent,
    EmailComposeCellComponent
  ],
  exports: [
    FilterBarComponent,
    BhubTreeComponent,
    DatePickerComponent,
    DatePickerModalComponent,
    FileBrowserModalComponent,
    // View Cell Components
    TextCellComponent,
    FilterListCellComponent,
    MultiSelectCellComponent,
    ListDisplayCellComponent,
    InputFieldCellComponent,
    CheckboxCellComponent,
    ActionCellComponent,
    DataDisplayCellComponent,
    NoteBlockCellComponent,
    RadialButtonCellComponent,
    DatetimePickerCellComponent,
    ImageCellComponent,
    DataEntryCellComponent,
    LookupCellComponent,
    // PDF Cell Components
    PdfTextCellComponent,
    PdfImageCellComponent,
    PdfFieldCellComponent,
    PdfTableCellComponent,
    PdfPageBreakCellComponent,
    PdfDatetimeCellComponent,
    PdfRowCellComponent,
    CalculationCellComponent,
    ListCalcCellComponent,
    PdfListCalcCellComponent,
    DataEntryTableCellComponent,
    FileReferenceCellComponent,
    PdfGridCellComponent,
    PdfCheckboxCellComponent,
    PdfLineCellComponent,
    EmailComposeCellComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    ButtonModule,

    //PrimeNg
    TreeModule,
    ListboxModule,

    //Material
    MatFormFieldModule,
    MatSelectModule,
    MatOptionModule,
    MatButtonModule,
    MatIconModule,
    MatButtonToggleModule,
    MatInputModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatDialogModule,
    MatProgressSpinnerModule,
    MatCheckboxModule,
    MatTooltipModule,
    MatMenuModule,
  ]
})
export class BhubCommonModule { }
